const updateChangeJavascriptState = () => {

    const selectedPage = JSON.parse(localStorage.getItem('selectedPage'));
    const selectedProject =JSON.parse(localStorage.getItem('selectedProject'));
    const projectsData = JSON.parse(localStorage.getItem('data'));

    projectsData[selectedProject].pages[selectedPage].javascript.changeJavascript = true;
    localStorage.setItem('data', JSON.stringify(projectsData));
}

const syncUndoRedoActionsWithJavascript = (editor) => {
    editor.on('run:core:undo', () => {

        updateChangeJavascriptState();
    })

    editor.on('run:core:redo', () => {
        updateChangeJavascriptState();
    })
}

export default syncUndoRedoActionsWithJavascript;
